// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202610080836/js/" + chunkId + "." + {"44":"90891438","225":"6e2deab9","481":"d5711910","486":"c8cf61ff","770":"269caa57"}[chunkId] + ".0.3051382993539351.chunk.js";
};